import accountTableTemplate from "../reporting/reactReportingAccountsTable.html";
import {DELETEROUTE, DELETETITLE} from "../accounts/reactAdministrationAccountsTable.directive";
import {ReactTableController} from "../../reactTableController";
import {accounts, USER_ACC_REACT} from "../../../../services/arsweb/RoutingPaths";
import {NON_REPORTING_ACCOUNTS} from "../../../../services/arsweb/TableTitles";
import {reactReportingAccountCols, defaultSortModel} from "./reportingAccountsColDefs";
import {AccountService} from "../../../../services/AccountService";

/** @ngInject */
export function reactReportingAccountsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@'
        },
        templateUrl: accountTableTemplate,
        controller: ReactReportingAccountsTableController,
        controllerAs: 'reactReportingAccountsTable'
    };
}

/** @ngInject */
export class ReactReportingAccountsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies ) {

        super($scope, userService, arsMainDependencies, '', new AccountService(userService), accounts,
            NON_REPORTING_ACCOUNTS, 'noReportingAccountsTableParams', "accountName", true, [], defaultSortModel);
        this.backendService.service.config.params.filter = { predefinedQuery: NON_REPORTING_ACCOUNTS };
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));
    }

    initGrid(userService) {

        userService.promise.then(()=> {

            // react account columns
            this.colDefs = reactReportingAccountCols(this.translate, userService);
			this.initCols();
            this.globalActions.push({label: this.translate.instant(DELETETITLE),
                handleAction:() => this.delete(this.gridApi.getSelectedNodes(),DELETEROUTE + 'Confirmation')});
            // react gridParameters for account table
            const accountGridParams = {
                columnDefs: this.colDefs,
                columnMapping: {'currencyCode' : 'currency'},
                url: this.backendService.service.getServiceUrl(USER_ACC_REACT + accounts)
            };
            delete this.defaultReactGridParams.onReport;
            delete this.defaultReactGridParams.onSearchInputChange;
            this.reactGridParams = {...this.defaultReactGridParams, ...accountGridParams};
        })
    }
}
